import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Transaction, TransactionProgress, TransactionVendorReference } from '@fry/payments/lib';
import { TracksOperationProgress } from '@fry/components/common';
import { PaymentGatewayIntegration } from '../integrations/integration';


/**
  * Component presenting Payment Gateway (Vendor) additional verification
  * challenge (3D secure for example)
  *
  * This component is responsible for communicating with the Vendor in order
  * to perform aditional verification.
  *
  * Outcome of the component interaction success or failure of the verification.
  */
@Component({
    selector: 'eas-payments-card-action',
    templateUrl: './transaction.card.action.component.html',
    standalone: false
})
export class TransactionCardActionComponent implements OnDestroy,
                                                       AfterViewInit,
                                                       TracksOperationProgress {
    @Input() isOperationInProgress = false;
    @Input() transaction!: Transaction;
    @Input() progress!: TransactionProgress;
    @Input() integration!: PaymentGatewayIntegration;
    @Output() cancel = new EventEmitter<void>();
    @Output() capture = new EventEmitter<TransactionVendorReference>();
    @Output() error = new EventEmitter<Error>();

    constructor() { }

    ngAfterViewInit() {
        this.integration.initialize().subscribe(() => {
            this.integration.handleVerificationChallenge(this.progress.vendor)
                            .then(reference => {
                                this.capture.emit(reference);
                            })
                            .catch(error => {
                                this.error.emit(error);
                            });
        });
    }

    ngOnDestroy() { }

    onCancel() {
        this.cancel.emit();
    }
}
